import { Tooltip, Typography } from "antd";
import { Link } from "react-router-dom";

type Props = {
  link?: string;
  text: string;
  textToBeCopied?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
};

export default function TableIdButton(props: Props) {
  const TextComp = ({ children }) => {
    if (props?.link) {
      return (
        <Link
          to={props.link}
          style={{
            cursor: "pointer",
            ...props.style,
          }}
          target={props.link.startsWith("http") ? "_blank" : ""}
        >
          {children}
        </Link>
      );
    }

    return <>{children}</>;
  };

  return (
    <TextComp>
      <Tooltip title={props?.textToBeCopied}>
        <Typography.Text
          style={{
            ...(props?.onClick && { cursor: "pointer" }),
            ...props.style,
          }}
          copyable={
            !!props?.textToBeCopied?.length
              ? { text: props.textToBeCopied }
              : undefined
          }
          ellipsis
          onClick={props?.onClick}
          className={`${props?.onClick ? "clickable" : ""}`}
        >
          {props.text}
        </Typography.Text>
      </Tooltip>
    </TextComp>
  );
}
